<template>
    <div class="section cta-section">
        <h2>Start practicing tonight</h2>
        <div class="cta-buttons">
            <router-link to="/register" class="btn btn-primary-large">
                Get Started Free
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CTASection'
};
</script>

<style scoped>
.section {
    position: relative;
    z-index: 2;
    padding: 80px 20px;
    max-width: 80vw;
    margin: 0 auto;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-bottom: 1px solid var(--accent);
}

.cta-section {
    background: transparent;
    text-align: center;
    padding: 100px 20px;
}

.cta-section h2 {
    font-size: 42px;
    color: var(--text-secondary);
    margin-bottom: 20px;
}

.cta-buttons {
    display: flex;
    gap: 20px;
    justify-content: center;
    flex-wrap: wrap;
}

.btn {
    padding: 15px 40px;
    text-decoration: none;
    font-weight: 600;
    font-size: 16px;
    transition: transform 0.2s, box-shadow 0.2s;
    display: inline-block;
    border-radius: 8px;
}

.btn-primary-large {
    background: var(--accent);
    color: var(--bg-primary);
    padding: 20px 50px;
    font-size: 18px;
}

.btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
}

@media (max-width: 768px) {
    .cta-section h2 {
        font-size: 32px;
    }
    
    .section {
        min-height: auto;
        padding: 60px 20px;
    }
}
</style>